import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const TABS = [
  { label: 'Apply', path: '/preview/apply' },
  { label: 'Guide', path: '/preview/guide' },
  { label: 'Library', path: '/preview/library' },
];

export default function PreviewLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#FAF6F1' }}>
      {/* Top accent bar */}
      <Box
        sx={{
          height: 4,
          background: 'linear-gradient(90deg, #F59E0B 0%, #EF4444 25%, #3B82F6 50%, #10B981 75%, #8B5CF6 100%)',
        }}
      />

      {/* Navigation */}
      <Box
        sx={{
          height: 56,
          borderBottom: '1px solid #E8E0D8',
          px: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: '#FFFCF8',
          flexShrink: 0,
        }}
      >
        {/* Left: Brand */}
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 16,
            color: '#1A1A1A',
            cursor: 'pointer',
            letterSpacing: '-0.01em',
          }}
          onClick={() => navigate('/preview/guide')}
        >
          apply pub
        </Typography>

        {/* Center: Tabs */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {TABS.map((tab) => {
            const active = isActive(tab.path);
            return (
              <Box
                key={tab.path}
                onClick={() => navigate(tab.path)}
                sx={{
                  px: 2,
                  py: 0.75,
                  borderRadius: 1,
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: active ? 600 : 400,
                  color: active ? '#1A1A1A' : '#6B7280',
                  bgcolor: active ? '#E8F5E9' : 'transparent',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    bgcolor: active ? '#E8F5E9' : '#F0ECE6',
                  },
                }}
              >
                {tab.label}
              </Box>
            );
          })}
        </Box>

        {/* Right: Help */}
        <IconButton size="small" sx={{ color: '#9CA3AF' }}>
          <HelpOutlineIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
